import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';

import { Sidebar, Topbar } from './components';
import Footer from '../Footer';

const useStyles = makeStyles(theme => ({
  root: {
    height: 'auto',
    backgroundColor: '#f5f5f5',
    margin: '0 auto',
    paddingTop: '48px',

    [theme.breakpoints.up('lg')]: {
      paddingTop: '60px',
    }
  },
  mainWarp: {
    height: 'auto',
    [theme.breakpoints.up('lg')]: {
      display: "flex",
      flexWrap: "nowrap",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "flex-start",
    }
  },
  sideBar: {
    // [theme.breakpoints.up('lg')]: {
    // },
  },
  content: {
    height: 'auto',
    width: '100%',
    padding: theme.spacing(2.4),
    paddingRight: 0,
    maxWidth: 950,
    [theme.breakpoints.down('md')]: {
      margin: '0 auto',
      padding: theme.spacing(1.6),
    },
  },
}));

const Main = props => {
  const { children } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = React.useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  return (
    <div
      className={clsx({
        [classes.root]: true,
      })}
    >
      <Topbar
        onSidebarOpen={handleSidebarOpen}
      />

      <div className={classes.mainWarp}>
        <Sidebar
          className={classes.sideBar}
          onClose={handleSidebarClose}
          open={shouldOpenSidebar}
          variant={isDesktop ? 'persistent' : 'temporary'}
        />
        <main className={classes.content} style={{ height: "auto" }}>
          {children}
          <Footer />
        </main>
      </div>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default Main;
